<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div slot="body">
        <answer-option-list
          :config="config"
          prop="value"
          :answerValidate="answerValidate"
          :model="config"
          optionKey="optionName"
          optionValueKey="id"
          :multiple="true"
        ></answer-option-list>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
export default {
  name: 'CheckBoxAnswer',
  props: ['config'],
  data () {
    return {
      answerValidate
    }
  },
  components: {},
  watch: {
  },
  computed: {},
  methods: {
    selectItem (item) {
      const value = this.config.value
      const valueIndex = this.selectedIndex(item)
      valueIndex === -1 ? value.push(item.id) : value.splice(valueIndex, 1)
    },
    selectedIndex (item) {
      return this.config.value.findIndex(id => id === item.id)
    }
  },
  created () {},
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/CheckBox/CheckBoxAnswer.vue